import { useEffect, useState } from 'react'
import { Box, Button, Card, CardContent, Typography, Paper } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import EditIcon from '@mui/icons-material/Edit'
import Swal from 'sweetalert2'

// Component ย่อย
import ChangePasswordModal from './ChildComponent/ChangePasswordModal'

// Custom Hooks
import useAuthentication from './Hooks/useAuthentication'

export default function UserManage() {
    const [rowId, setRowId] = useState(undefined)
    const [userList, setUserList] = useState([])
    const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false)

    // เรียกใช้โรงงานประมวลผลระบบสิทธิ์
    const { fetchUserList } = useAuthentication()

    // 🟢 โหลดข้อมูลผู้ใช้ทั้งหมดด้วยระบบ SweetAlert2 
    useEffect(() => {
        const loadUsers = async () => {
            try {
                Swal.fire({
                    title: 'กำลังโหลดบัญชีผู้ใช้งาน...',
                    allowOutsideClick: false,
                    didOpen: () => { Swal.showLoading(); }
                });
                await fetchUserList(setUserList);
                Swal.close();
            } catch (err) {
                console.error(err);
                Swal.fire({ icon: 'error', title: 'ดึงข้อมูลล้มเหลว', text: 'ไม่สามารถโหลดรายชื่อผู้ใช้งานระบบได้' });
            }
        };
        loadUsers();
    }, []);

    // กำหนดรูปแบบตารางจัดระเบียบคอลัมน์
    const columns = [
        { field: 'id', headerName: 'ลำดับ', width: 80 },
        { field: 'username', headerName: 'ชื่อผู้ใช้ (Username)', width: 160 },
        { field: 'fname', headerName: 'ชื่อ', width: 150 },
        { field: 'lname', headerName: 'นามสกุล', width: 150 },
        { field: 'role_name', headerName: 'สิทธิ์การใช้งานระบบ', width: 300 },
        {
            field: 'action',
            headerName: 'การจัดการ',
            sortable: false,
            width: 200,
            renderCell: (params) => {
                return (
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<EditIcon />}
                        onClick={() => {
                            console.log(params.row.id)
                            setRowId(params.row.id);
                            setChangePasswordModalOpen(true);
                        }}
                    >
                        เปลี่ยนรหัสผ่าน
                    </Button>
                )
            }
        }
    ];

    return (
        // 🟢 ลบสไตล์ mt ค้างเก่าออกให้หมด ปล่อยให้คลาส .otherSide ใน index.css ดันระยะ Top 85px ให้เองแบบหล่อๆ
        <Box className='otherSide' id="otherSide" sx={{ p: 3, bgcolor: '#f4f6f8' }}>
            <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
                <CardContent>

                    {/* หัวข้อหน้าจอแบบโมเดิร์น */}
                    <Typography variant='h5' fontWeight="bold" color="primary.main" mb={3}>
                        👥 ระบบบริหารจัดการสิทธิ์บัญชีผู้ใช้งาน (User Management)
                    </Typography>

                    {/* แสดงตาราง DataGrid คลีนๆ สบายตา ครอบด้วยกระดาษ Paper ขอบมน */}
                    <Paper variant="outlined" sx={{ width: '100%', height: 500, overflow: 'hidden' }}>
                        <DataGrid
                            rows={userList}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[10, 20, 50]}
                            disableSelectionOnClick
                        />
                    </Paper>

                </CardContent>
            </Card>

            {/* หน้าต่างโมดอลย่อยสำหรับเปลี่ยนรหัสผ่าน (ส่งรับ Props ท่ามาตรฐาน) */}
            <ChangePasswordModal
                changePasswordModalOpen={changePasswordModalOpen}
                setChangePasswordModalOpen={setChangePasswordModalOpen}
                rowId={rowId}
                setRowId={setRowId}
            />
        </Box>
    )
}